module.exports = __webpack_public_path__ + "img/carrusel_4.0d419931.jpg";